import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostBinding, OnDestroy, OnInit, Renderer2, RendererStyleFlags2, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { StyleClassModule } from 'primeng/styleclass';
import { PageHeaderService } from '../../components/page-header/page-header.service';
import { AdminLayoutMenuComponent } from './admin-layout-menu/admin-layout-menu.component';
import { WindowSizeDirective } from '../../directives/window-size.directive';
import { AdminLayoutService } from './admin-layout.service';
import { ButtonModule } from 'primeng/button';
import { PortalModule } from '@angular/cdk/portal';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { TranslateModule } from '@ngx-translate/core';

export const HEADER_PORTAL_CONTAINER_ID = 'header-portal-container';
export const MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID = 'mobile-header-portal-right-content-container';
export const MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID = 'mobile-header-portal-under-content-container';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule, RouterModule, PortalModule,
    StyleClassModule, ButtonModule,
    AdminLayoutMenuComponent, NgbTooltipModule, TranslateModule
  ],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  hostDirectives: [ WindowSizeDirective ]
})
export class AdminLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  HEADER_PORTAL_CONTAINER_ID = HEADER_PORTAL_CONTAINER_ID;
  MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID = MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID;
  MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID = MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID;

  @HostBinding('class.admin-layout--no-content-padding') get noContentPadding() {
    return !this.adminLayoutService.showContentPadding$.value;
  }
  @ViewChild('adminMobileHeader') adminMobileHeader: ElementRef<any> | undefined;
  adminMobileHeaderObserver: ResizeObserver | undefined;

  constructor(
    public adminLayoutService: AdminLayoutService,
    private modalService: NgbModal,
    public pageHeaderService: PageHeaderService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
  }

  @ViewChild(CdkPortalOutlet, {static: true}) secondaryContentPortalOutlet: CdkPortalOutlet | undefined;
  
  ngAfterViewInit() {
    if (this.secondaryContentPortalOutlet) this.adminLayoutService.setSecondaryContentPortalOutlet(this.secondaryContentPortalOutlet);

    this.adminMobileHeaderObserver = new ResizeObserver((entries) => {

      const el = this.adminMobileHeader!.nativeElement as HTMLElement;
      const { height } = el.getBoundingClientRect();
      this.renderer.setStyle(
        document.documentElement,
        '--admin-mobile-header-height',
        `${height}px`,
        RendererStyleFlags2.DashCase
      );
    });
    this.adminMobileHeaderObserver.observe(this.adminMobileHeader!.nativeElement);
  }

  onOpenModal(el: TemplateRef<any>) {
    const ref = this.modalService.open(el, {
      windowClass: 'modal-down'
    });

    setTimeout(() => {
      this.pageHeaderService.port.next(true);
    });

    ref.result.finally(() => {
      this.pageHeaderService.port.next(false);
      setTimeout(() => {
        (document.activeElement as HTMLElement)?.blur(); // Remove focus from any active element
      })
    });
  }


  ngOnDestroy(): void {
    this.adminMobileHeaderObserver?.disconnect();
  }
}
